const WIDGET_THEMES = ['spherum', 'default', 'max', 'postupai'] as const;

export type WidgetTheme = (typeof WIDGET_THEMES)[number];

export const isWidgetTheme = (value: string): value is WidgetTheme =>
  (WIDGET_THEMES as readonly string[]).includes(value);
